module.exports = __webpack_public_path__ + "static/media/ni.48b64edc.svg";